/* eslint-disable max-len */
import cx from 'clsx';

// types
// styles
import { useStyles } from './shared/styles';

const Connect = ({ className, color, onClick }) => {
  const classes = useStyles();

  return (
    <svg
      className={cx({
        [classes.root]: true,
        [className || '']: className,
      })}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        d="M17.657 14.828L16.243 13.414L17.657 12C18.0285 11.6286 18.3231 11.1876 18.5241 10.7023C18.7252 10.217 18.8286 9.69681 18.8286 9.1715C18.8286 8.6462 18.7252 8.12605 18.5241 7.64073C18.3231 7.15542 18.0285 6.71445 17.657 6.343C17.2856 5.97156 16.8446 5.67691 16.3593 5.47589C15.874 5.27487 15.3538 5.1714 14.8285 5.1714C14.3032 5.1714 13.7831 5.27487 13.2977 5.47589C12.8124 5.67691 12.3715 5.97156 12 6.343L10.586 7.757L9.17201 6.343L10.586 4.929C11.7143 3.81892 13.2356 3.19966 14.8184 3.2061C16.4012 3.21255 17.9174 3.84418 19.0366 4.96341C20.1558 6.08265 20.7875 7.5988 20.7939 9.18162C20.8004 10.7644 20.1811 12.2857 19.071 13.414L17.657 14.828V14.828ZM14.828 17.657L13.414 19.071C12.8585 19.6356 12.1968 20.0846 11.4669 20.3922C10.737 20.6998 9.95343 20.8598 9.16139 20.863C8.36936 20.8662 7.58452 20.7126 6.85215 20.411C6.11979 20.1094 5.45438 19.6658 4.89432 19.1057C4.33426 18.5456 3.89063 17.8802 3.58902 17.1479C3.28741 16.4155 3.13379 15.6307 3.13701 14.8386C3.14024 14.0466 3.30025 13.263 3.60781 12.5331C3.91538 11.8033 4.36441 11.1415 4.92901 10.586L6.34301 9.172L7.75701 10.586L6.34301 12C5.97157 12.3714 5.67692 12.8124 5.4759 13.2977C5.27488 13.783 5.17141 14.3032 5.17141 14.8285C5.17141 15.3538 5.27488 15.874 5.4759 16.3593C5.67692 16.8446 5.97157 17.2856 6.34301 17.657C6.71446 18.0284 7.15543 18.3231 7.64074 18.5241C8.12605 18.7251 8.64621 18.8286 9.17151 18.8286C9.69681 18.8286 10.217 18.7251 10.7023 18.5241C11.1876 18.3231 11.6286 18.0284 12 17.657L13.414 16.243L14.828 17.657ZM14.828 7.757L16.243 9.172L9.17201 16.242L7.75701 14.828L14.828 7.758V7.757Z"
        fill={color}
      />
    </svg>
  );
};

export default Connect;
